import { Chip, SxProps, Theme } from '@mui/material';
import { ReadinessState } from '../../../shared/services/readiness/readiness.model';
import { READINESS_STATE_LABELS } from './readiness-labels';

// Red is reserved for genuine failures, and amber read as an alarm the state does not warrant.
// Not ready is work still to do, so it wears the brand ink rather than a status colour; the
// states then read ink, blue, green.
const INK_STATE_SX: SxProps<Theme> = { borderColor: 'text.primary', color: 'text.primary' };

const stateColor = (state: ReadinessState): 'info' | 'success' | undefined => {
  if (state === 'not_ready') return undefined;
  if (state === 'reportable_with_caveats') return 'info';
  return 'success';
};

type Props = {
  state: ReadinessState;
  sx?: SxProps<Theme>;
  // Medium on the readiness page heading; small inside table cells (the partner Clients page).
  size?: 'small' | 'medium';
};

// The headline readiness state: one of three named states, never a percentage.
export const ReadinessStateChip = ({ state, sx, size = 'medium' }: Props) => {
  const color = stateColor(state);
  return (
    <Chip
      label={READINESS_STATE_LABELS[state]}
      color={color}
      size={size}
      variant='outlined'
      sx={{ ...(color ? {} : INK_STATE_SX), ...sx }}
    />
  );
};
